import { makeStyles } from '@material-ui/core';

var useIconStyles = makeStyles(function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    var getFontSize = function (_a) {
        var size = _a.size;
        var sizes = {
            inherit: 'inherit',
            small: spacing(1.5),
            medium: spacing(2),
            large: spacing(2.5),
            'extra-large': spacing(3),
        };
        if (!size || !sizes[size])
            return 'inherit';
        return sizes[size];
    };
    var getColor = function (props) {
        var semanticColors = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
        var value = 'inherit';
        if (props.color) {
            if (semanticColors.includes(props.color.split('.')[0])) {
                var _a = props.color.split('.'), color = _a[0], _b = _a[1], variant = _b === void 0 ? 'main' : _b;
                // @ts-expect-error - todo.
                value = palette[color][variant];
            }
            else if (props.color.search(/^(rgb|hsla|#)/) !== -1) {
                value = props.color;
            }
        }
        return value;
    };
    return {
        root: {
            color: getColor,
            fontSize: getFontSize,
            width: '1em',
            height: '1em',
            strokeWidth: '1.3px',
        },
    };
});

export { useIconStyles };
//# sourceMappingURL=IconStyles.js.map
